<div class="container mt-4">
  <div class="heading">
    <h4 class="text-uppercase">{{ 'leaderboard.title' | translate }}</h4>
  </div>

  <div class="font-size-14 my-3">
    {{ 'leaderboard.description' | translate }}
  </div>

  <a href="{{ 'leaderboard.button.url' | translate }}">
    <div class="btn btn-secondary font-praktika-bold mb-3">{{ 'leaderboard.button' | translate }}</div>
  </a>

  <fgb-leaderboard [toShow]="20" [LeaderboardType]="LeaderboardType"></fgb-leaderboard>
</div>
